import React from "react";
import "./Activitse.css";
import LoadingSkeleton from "./LoadingSkeleton";
import SingleActivity from "./SingleActivity";

const ActivitiesContent8 = (props) => {
  
  return (
    <>
      <div className="row mt-3">
        {props.loader ? (
          props.event.map((event) => {
            return (
              <>
                <SingleActivity event={event} event_type="greeting" />
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent8;
